import { Card, CardBody, CardText, CardTitle } from "reactstrap";

import { apiSlice } from "app/apiSlice";
import Loader from "components/Loader";
import { currencyFormatter } from "helpers/formatters";

const SegmentedBalanceCard = ({
  // loading,
  // stripeBalancePending,
  // stripeBalanceAvailable,
  // stripeBalanceTotal,
  // pendingTopups,
  // pastTopups,
  ...props
}) => {
  const { data, isFetching } = apiSlice.useGetTopupsQuery();
  const stripeBalances = data?.result;
  return (
    <Card>
      <CardBody>
        {isFetching && <Loader />}
        <CardTitle>
          <h2 className="fs-4">Segmented Balances</h2>
        </CardTitle>
        <CardText className="dashboard__content__labelled-data">
          <span>
            <span className="small text-muted mb-2">Available</span>
            {currencyFormatter(stripeBalances?.nonPlatformAvailableBalance)}
          </span>
          <span>
            <span className="small text-muted mb-2">Pending</span>
            {currencyFormatter(stripeBalances?.nonPlatformPendingBalance)}
          </span>
          <span>
            <span className="small text-muted mb-2">Total</span>
            {currencyFormatter(stripeBalances?.nonPlatformTotalBalance)}
          </span>
        </CardText>
      </CardBody>
    </Card>
  );
};

export default SegmentedBalanceCard;
